import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Resume from '../components/resume';
import MyAchievements from '../components/My_Achievements';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WolfChatbot from '../components/WolfChatbot';

const Home = () => {
  const [, setIsChatbotOpen] = useState(false);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <div className="atmosphere" />
      <div className="grain" />
      <div className="site-content">
        <Navbar />
        <Hero />
        <About />
        <Resume />
        <Projects />
        <MyAchievements />
        <Contact />
        <Footer />
      </div>
      <WolfChatbot onChatToggle={setIsChatbotOpen} />
    </div>
  );
};

export default Home;
